// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"dffc004f","520":"e46a3764","864":"4e4b1280"}[chunkId] + ".chunk.js";
};